export function isNonNullObject(obj) {
  return obj !== null && typeof obj === 'object';
}